import { render, staticRenderFns } from "./PackingsCell.vue?vue&type=template&id=9fdb5b16&"
import script from "./PackingsCell.vue?vue&type=script&lang=js&"
export * from "./PackingsCell.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports